(function () {
  'use strict';

  class TrackingUnavailableError extends Error {}

  class TrackingService {
    constructor(options) {
      this.demoMode = Boolean(options && options.demoMode);
      this.provider = this.demoMode ? window.TrackOrderDemoProvider : null;
    }

    async lookup(input) {
      if (!this.provider) {
        throw new TrackingUnavailableError('Live tracking is not connected.');
      }
      return this.provider.lookup(input);
    }
  }

  window.TrackingService = TrackingService;
  window.TrackingUnavailableError = TrackingUnavailableError;
})();
